module.exports = __webpack_public_path__ + "static/media/profile_asahisoa422b11be970af306eec7ea9b40f861db.webp";